import React from 'react';
import { Trans, useTranslation } from "react-i18next";
import classNames from "classnames";
import Footer from 'components/Footer';

const LayoutLandingPage = (props) => {
    const { i18n } = useTranslation();
    const dir = i18n.dir();

    const classString = " old-style "+ dir
    
    return (
        // <div> LayoutLandingPage {children}</div>
        <>
            <div id="main" dir={dir} className={classString} style={{ flex: "1 0 auto", background:"#FFF" }}>
                {props.children}
                <div className="page-wrapper d-block" style={{background:"#FFF"}}>
                    <div className="page-content container-fluid">
                        {props.body}
                    </div>
                </div>
                <div dir={dir} className={classNames(dir, "d-print-none")} style={{background:"#222"}}>
                    {/* {!user ? <Footer /> : <></>} */}
                    {/* {_showHeader ? <Footer /> : null} */}
                    {/* { (_showHeader && !user ) ? <Footer /> : null} */}
                    <Footer /> 
                </div>
            </div>
        </>
    );
}
export default LayoutLandingPage;
